import { useAtomValue } from 'jotai';
import { isBookingMultiDayAtom, selectedBookingPackageAtom } from 'components/forms/bookingWidget/jotaiStore';
import styled from 'styled-components';
import SelectInput from '../../TimePicker/SelectInput';
import DurationIcon from './DurationIcon';
import { getBoatAvailableOptions } from './utils';

const DurationPicker = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
  onChange = (e) => {},
  defaultValue,
  setter,
  error = null,
  className = null,
  modalVersion = false,
}) => {
  const isBookingMultiDay = useAtomValue(isBookingMultiDayAtom);
  const selectedBookingPackage = useAtomValue(selectedBookingPackageAtom);

  const options = getBoatAvailableOptions(selectedBookingPackage);

  return (
    <DurationPickerWrapper data-testid="pdp-booking-widget-duration-picker-container">
      <SelectInput
        modalVersion={modalVersion}
        setter={setter}
        name="DurationPicker"
        object="duration_picker"
        error={error}
        options={options}
        icon={<DurationIcon />}
        className={className}
        defaultValue={defaultValue}
        onChange={onChange}
        title="Duration"
        height="auto"
        isDisabled={isBookingMultiDay}
      />
    </DurationPickerWrapper>
  );
};

const DurationPickerWrapper = styled.div`
  margin-bottom: 0px;
`;

export default DurationPicker;
